// account.tsx
// Route : /account — page "Mon compte", accessible à tout utilisateur
// authentifié (Microsoft ou local), sans restriction de rôle ou permission.

import { createFileRoute } from "@tanstack/react-router";

import { AppLayout } from "@/presentation/layouts/AppLayout";
import { AccountPage } from "@/presentation/pages/AccountPage";

export const Route = createFileRoute("/account")({
  component: function AccountRouteComponent() {
    return (
      <AppLayout>
        <AccountPage />
      </AppLayout>
    );
  },
});
